<dc-filter-bar [options]="filterBarOptions" [customFilters]="customFilters" (onFilterAction)="applyFilterBarEvent($event)" (onNew)="onNew()"></dc-filter-bar>
@if(viewType() === 'table') {

<app-quick-table [tableData]="items()" (onAction)="doAction($event)"></app-quick-table>

} @else {
<div class="lesson-list-container">
  @if (items()?.length > 0) { @for (lesson of items(); track lesson._id) {
  <ng-container
    #outlet="ngComponentOutlet"
    [ngComponentOutlet]="cardComponent"
    [ngComponentOutletInputs]="{
      lesson: lesson,
      showOptions: true
    }">
  </ng-container>

  } } @else {
  <p>No se encontraron lecciones disponibles</p>
  }
</div>
}

<p-paginator
  currentPageReportTemplate="{{ totalRecords }} lecciones"
  [showCurrentPageReport]="true"
  (onPageChange)="onPageChange($event)"
  [totalRecords]="totalRecords"
  [first]="first"
  [rows]="rows"
  [rowsPerPageOptions]="[10, 20, 30]">
</p-paginator>
